import React, { useEffect, useState } from 'react'
import { get_departments, fetchUserRoles } from '../../../helper/Api';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { FaRegEdit } from "react-icons/fa"
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import './ManageDepartment.css';
import Spinner from '../../Tools/spinner';

const ManageDepartment = ({searchStr, tier}) => {
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { authData } = useSelector((state) => state.authData);
  const dispatch = useDispatch();
  const [departments, setDepartments] = useState([]);
  const [showUsersModal, setShowUsersModal] = useState(false);
  const [usersLoading, setUsersLoading] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [userRolesData, setUserRolesData] = useState([]);

  const fetchDepartments = async () => {
    try {
      setLoading(true);
      const departments = await get_departments({ department_level: tier, searchStr: searchStr, parent_department_id: authData.user.department_id != 1 ? authData.user.department_id : null });
      if (departments.data.status) {
        setDepartments(departments.data.result);
      } 
    } catch (error) {
      toast.error(error?.message || "Failed to fetch departments", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      setLoading(false);
    }
  }

  const handleViewUsers = async (row) => {
    setLoading(true);
    setSelectedDepartment(row);
    setShowUsersModal(true);
    setUsersLoading(true);
    setUserRolesData([]);

    try {
      // Placeholder API call for user roles; replace this with actual roles API later.
      const response = await fetchUserRoles(row.id);
      if (response?.data?.status) {
        setUserRolesData(response?.data?.result || []);
      } else {
        toast.error(response?.data?.message || "Failed to fetch user roles", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error(error?.message || "Failed to fetch user roles", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      setUsersLoading(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, [dispatch, searchStr, tier])

  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "14px"
      },
    },
  };

  const getPaymentModeMeta = (paymentMode) => {
    const mode = String(paymentMode || "").toLowerCase();

    if (mode === "1" || mode === "online") {
      return {
        label: "Online",
        bg: "#e6f4ea",
        color: "#1e7e34",
      };
    }

    if (mode === "2" || mode === "offline") {
      return {
        label: "Offline",
        bg: "#fff4e5",
        color: "#b26a00",
      };
    }

    if (mode === "3" || mode === "both") {
      return {
        label: "Both",
        bg: "#e8f0ff",
        color: "#1f4db8",
      };
    }

    return {
      label: "N/A",
      bg: "#f1f3f5",
      color: "#5f6368",
    };
  };

  const getRoleMeta = (roleValue) => {
    const role = String(roleValue || "").toLowerCase();

    if (role === "l1" || role === "1") {
      return {
        label: "L1",
        bg: "#e8f0ff",
        color: "#1f4db8",
      };
    }

    if (role === "l2" || role === "2") {
      return {
        label: "L2",
        bg: "#fff4e5",
        color: "#b26a00",
      };
    }

    if (role === "l3" || role === "3") {
      return {
        label: "L3",
        bg: "#e6f4ea",
        color: "#1e7e34",
      };
    }

    return {
      label: "N/A",
      bg: "#f1f3f5",
      color: "#5f6368",
    };
  };

  const columns = [
    {
      name: 'Code',
      selector: (row) => row.code,
      sortable: true,
      width: "10%"
    },
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
      wrap: true,
      width: "15%"
    },
    {
      name: 'Department Level',
      selector: (row) => row.nomiclature,
      sortable: true,
      wrap: true,
      width:"10%"
    },
    {
      name: 'Tier',
      selector: (row) => row.department_level,
      sortable: true,
      wrap: true,
      width:"10%"
    },
    {
      name: 'Payment Mode',
      selector: (row) => getPaymentModeMeta(row.payment_mode).label,
      cell: (row) => {
        const mode = getPaymentModeMeta(row.payment_mode);
        return (
          <span
            style={{
              backgroundColor: mode.bg,
              color: mode.color,
              padding: '4px 10px',
              borderRadius: '999px',
              fontSize: '12px',
              fontWeight: 600,
              lineHeight: 1.2,
            }}
          >
            {mode.label}
          </span>
        );
      },
      sortable: true,
      wrap: true,
      width: '10%'
    },
    {
      name: 'User Roles',
      selector: (row) => row.user_roles,
      cell: (row) => (
        <div className='d-flex align-items-center gap-2'>
          <button
            type='button'
            className='btn btn-outline-primary btn-sm'
            onClick={() => handleViewUsers(row)}
          >
            View Users
          </button>
        </div>
      ),
      sortable: true,
      wrap: true,
      width:"15%"
    },
    {
      name: 'Parent Dept. Name',
      selector: (row) => row.parent_department_name,
      sortable: true,
      wrap: true,
      width:"15%"
    },
    {
      name: 'Parent Dept. Tier',
      selector: (row) => row.parent_department_level,
      sortable: true,
      wrap: true,
      width:"10%"
    },
  ];
  if(authData.user.user_type === 'l3') {
    columns.push({
      name: 'Action',
      width: "10%",
      selector: (row) => {
        if(authData.user.department_details.department_level !== 'T1' && authData.user.department_details.id == row.id) {
          return
        } else {
          return (
            <div className='user_action'>
              <span className='pr-4'><Link to={`/edit-department/${row.id}`}><FaRegEdit /></Link></span>
            </div>
          );
        }
        
      },
      sortable: true,
    });
  }
  const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
    setRowsPerPage(currentRowsPerPage);
    setCurrentPage(1);
  };
  return (
    <div>
      {loading && <div > <Spinner/> </div>}
      <DataTable
        customStyles={customStyles}
        className="dataTables_wrapper"
        columns={columns}
        data={departments}
        fixedHeader
        fixedHeaderScrollHeight="600px"
        pagination
        paginationPerPage={rowsPerPage}
        paginationTotalRows={departments.length}
        paginationRowsPerPageOptions={[10, 25, 50, 100]}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />

      <Modal show={showUsersModal} onHide={() => setShowUsersModal(false)} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            View Users {selectedDepartment?.name ? `- ${selectedDepartment.name}` : ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {usersLoading ? (
            <p className="mb-0">Loading users...</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered table-striped mb-0" style={{ tableLayout: 'fixed', width: '100%' }}>
                <thead>
                  <tr>
                    <th style={{ width: '10%' }}>S.No.</th>
                    <th style={{ width: '30%' }}>User Info</th>
                    <th style={{ width: '45%' }}>Contact Info</th>
                    <th style={{ width: '15%' }}>Role</th>
                  </tr>
                </thead>
                <tbody>
                  {userRolesData.length > 0 ? (
                    userRolesData.map((user, index) => (
                      <tr key={user?.id || index}>
                        <td>{index + 1}</td>
                        <td><strong>{user?.user_name}</strong><br/>{user?.designation}</td>
                        <td><strong>{user?.email || "-"}</strong><br/>{user?.mobile}</td>
                        <td>
                          {(() => {
                            const role = getRoleMeta(user?.role || user?.user_role || user?.user_type);
                            return (
                              <span
                                style={{
                                  backgroundColor: role.bg,
                                  color: role.color,
                                  padding: '4px 10px',
                                  borderRadius: '999px',
                                  fontSize: '12px',
                                  fontWeight: 600,
                                  lineHeight: 1.2,
                                  display: 'inline-block',
                                }}
                              >
                                {role.label}
                              </span>
                            );
                          })()}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={5} className="text-center">No users found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ManageDepartment
